<template>
  <div class="sub-bread">
    <template v-for="(l, k) of list">
      <template v-if="k + 1 < list.length">
        <span class="default">{{ l.name }}</span>
        <span class="fa fa-angle-right"></span>
      </template>
      <template v-else>
        <span class="active">{{ l.name }}</span>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="less" scoped>
.sub-bread {
  background-color: #f8f8f8;
  padding: 10px 20px;

  .fa {
    margin: 0 10px;
  }

  .default {
    color: #888;
    &:hover {
      color: #0066ff;
    }
  }

  .active {
    color: #333;
    font-weight: 800;
  }
}
</style>
